"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defaultProps = _interopRequireDefault(require("recompose/defaultProps.js"));
var _react = _interopRequireDefault(require("react"));
var _cccisdLaravelBoilerplate = require("cccisd-laravel-boilerplate");
var _About = _interopRequireDefault(require("../../pages/About"));
var _Laravel = _interopRequireDefault(require("../../pages/Laravel"));
var _Logs = _interopRequireDefault(require("../../pages/Logs"));
var _cccisdLaravelShortUrls = require("cccisd-laravel-short-urls");
var _cccisdLaravelAssignment = require("cccisd-laravel-assignment");
var _cccisdLaravelResources = require("cccisd-laravel-resources");
var _cccisdLaravelLicensing = require("cccisd-laravel-licensing");
var _Root = _interopRequireDefault(require("../../Root.js"));
var _index = _interopRequireDefault(require("../../pages/Guide/index.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var Fortress = window.cccisd.fortress;

/*
 * To use, include the following line within the <Switch> in your routes.js
 * (where MainLayout is the layout you want used for each of the admin routes):
 *
 * {AdminRoutes(MainLayout)}
 */
var _default = exports["default"] = function _default(Layout) {
  var AdminRoute = (0, _defaultProps["default"])({
    layout: Layout
  })(_cccisdLaravelBoilerplate.Route);
  var routes = [];
  if (Fortress.hasAccess('appdefs.debug')) {
    routes.push(/*#__PURE__*/_react["default"].createElement(AdminRoute, {
      key: "About",
      path: "/appdefs/about",
      component: _About["default"]
    }));
  }
  if (Fortress.hasAccess('appdefs.debug')) {
    routes.push(/*#__PURE__*/_react["default"].createElement(AdminRoute, {
      key: "Laravel",
      path: "/appdefs/laravel",
      component: _Laravel["default"]
    }));
  }
  if (Fortress.hasAccess('appdefs.logs')) {
    routes.push(/*#__PURE__*/_react["default"].createElement(AdminRoute, {
      key: "Logs",
      path: "/appdefs/logs",
      component: _Logs["default"]
    }));
  }
  if (Fortress.hasAnyAccess(['quest.admin', 'quest.code', 'quest.deploy', 'quest.design', 'quest.export', 'quest.permissions', 'quest.status', 'quest.view_data'], 'anyTarget') || Fortress.settings.role === 'questprojectadmin') {
    routes.push(/*#__PURE__*/_react["default"].createElement(AdminRoute, {
      key: "Quest",
      path: "/quest",
      component: _cccisdLaravelAssignment.Quest
    }));
  }
  if (Fortress.hasAccess('resources.admin')) {
    routes.push(/*#__PURE__*/_react["default"].createElement(AdminRoute, {
      key: "Resources",
      path: "/resources/admin",
      component: _cccisdLaravelResources.ResourceManager,
      exact: true
    }));
  }
  if (Fortress.hasAccess('appdefs.admin')) {
    routes.push(/*#__PURE__*/_react["default"].createElement(AdminRoute, {
      key: "AppDefs",
      path: "/appdefs",
      component: _Root["default"]
    }));
  }
  if (Fortress.hasAccess('shorturls.admin')) {
    routes.push(/*#__PURE__*/_react["default"].createElement(AdminRoute, {
      key: "AppDefs",
      path: "/shorturls",
      component: _cccisdLaravelShortUrls.ShortUrls
    }));
  }
  if (Fortress.hasAnyAccess(['licensing.admin', 'licensing.licenses', 'licensing.courses', 'licensing.logs', 'licensing.vouchers', 'licensing.products'])) {
    routes.push(/*#__PURE__*/_react["default"].createElement(AdminRoute, {
      key: "LicensedProducts",
      path: "/licensed-products",
      component: _cccisdLaravelLicensing.ProductManage
    }));
  }
  if (Fortress.hasAnyAccess('quest.admin', 'anyTarget')) {
    routes.push(/*#__PURE__*/_react["default"].createElement(AdminRoute, {
      key: "UserGuide",
      path: "/guide",
      component: _index["default"]
    }));
  }

  // Public route needed for resource sharing
  routes.push(/*#__PURE__*/_react["default"].createElement(AdminRoute, {
    key: "ViewShare",
    path: "/resource/viewshare/:id/:hash",
    component: _cccisdLaravelResources.ViewShare,
    exact: true
  }));
  return routes;
};